
import useAxios from './Api';
import constants from "./Constants";

const useEndpoints = () => {

    const instance = useAxios();

    // Get networks
    const getNetworks = async (callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/networks', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Get crypto main wallets
    const getCryptoMainWallets = async (callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/crypto', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Get crypto wallets
    const getCryptoWallets = async (currency, start_item, end_item, page, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/crypto/wallets', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    network: currency,
                    start_item: start_item,
                    end_item: end_item,
                    page: page
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Get crypto balance
    const getCryptoBalance = async (network, address, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/crypto/balance', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    network: network,
                    address: address
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Get crypto receive details
    const getCryptoReceiveDetails = async (network, address, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/crypto/receive', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    network: network,
                    address: address
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Get crypto transactions
    const getCryptoTransactions = async (network, address, status, page, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            const start_item = (page - 1) * 10;
            const end_item = page * 10;
            var result = await instance.get(constants.urls.blockchain + '/crypto/transactions', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    network: network,
                    address: address,
                    status: status,
                    start_item: start_item,
                    end_item: end_item,
                    page: page
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Get card transactions
    const getCardTransactions = async (cardId, page, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            const start_item = (page - 1) * 10;
            const end_item = page * 10;
            var result = await instance.get(constants.urls.blockchain + '/cards/transactions', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    card_id: cardId,
                    start_item: start_item,
                    end_item: end_item,
                    page: page
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Get fiat wallets
    const getFiatWallets = async (callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/fiat', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // Get fiat transactions
    const getFiatTransactions = async (start_item, end_item, page, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/fiat/transactions', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    start_item: start_item,
                    end_item: end_item,
                    page: page
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET PAYMENT CARDS
    const getPaymentCards = async (start_item, end_item, page, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/cards', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    start_item: start_item,
                    end_item: end_item,
                    page: page
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET TRANSACTION ANALYTICS
    const getTransactionAnalytics = async (country_shortcode, period, expanded, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.analytics + '/transactions', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    country_shortcode: country_shortcode,
                    period: period,
                    expanded: expanded
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET ENDPOINT LOGS
    const getEndpointLogs = async (callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.analytics + '/logs', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    start_item: 0,
                    end_item: 100
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET ENDPOINT HISTORY
    const getEndpointHistory = async (period, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.analytics + '/logs/history', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    period: period
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET TOKEN TO AMOUNT CONVERSION
    const getTokenToAmountConversion = async (currency, token, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.payments + '/tokens/conversion', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    currency: currency,
                    token: token
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // BUY TOKENS
    const buyTokens = async (currency, token, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.post(constants.urls.payments + '/tokens/buy', {
                currency: currency,
                token: token
            }, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // CREATE FIAT WALLET
    const createFiatWallet = async (currency, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.post(constants.urls.blockchain + '/fiat', {
                currency: currency
            }, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET FIAT CURRENCIES
    const getFiatCurrencies = async (callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/fiat/currencies', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET PAYMENT ACCOUNT
    const getPaymentAccounts = async (currency, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.payments + '/accounts', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    currency: currency
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET CARD CURRENCIES
    const getCardCurrencies = async (callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/cards/currencies', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET FEES
    const getFees = async (identifier, amount, currency, debit_currency, provider, type, country_shortcode, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.payments + '/fiat/fees', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    identifier,
                    amount,
                    debit_currency,
                    provider,
                    type,
                    currency,
                    country_shortcode
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET CONVERSION RATES
    const getConversionRates = async (amount, from_currency, to_currency, category, provider, conversion_id, fee_id, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.payments + '/fiat/conversion', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    from_currency,
                    to_currency,
                    amount,
                    category,
                    provider,
                    conversion_id,
                    fee_id
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET CRYPTO CONVERSION RATES
    const getCryptoConversionRates = async (identifier, amount, network, currency, transfer_network, conversion_id, fee_id, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/conversion/crypto', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    identifier,
                    network,
                    amount,
                    currency,
                    transfer_network,
                    conversion_id,
                    fee_id
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // CALCULATE CRYPTO NETWORK FEE
    const calculateCryptoNetworkFee = async (mount, network, debit_currency, from_address, to_address, transfer_network, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.post(constants.urls.blockchain + '/networks/fees', {
                amount: mount,
                network: network,
                debit_currency: debit_currency,
                from_address: from_address,
                to_address: to_address,
                transfer_network: transfer_network
            }, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // BUY CRYPTO
    const buyCrypto = async (postData, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.post(constants.urls.blockchain + '/crypto/buy', postData, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // CREATE CARD
    const createCard = async (postData, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.post(constants.urls.blockchain + '/cards', postData, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // FUND CARD
    const fundCard = async (postData, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.post(constants.urls.blockchain + '/cards/fund', postData, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // WITHDRAW FROM CARD
    const withdrawFromCard = async (postData, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.post(constants.urls.blockchain + '/cards/withdraw', postData, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // CREATE CRYPTO WALLET
    const createCryptoWallet = async (postData, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.post(constants.urls.blockchain + '/crypto', postData, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    network: postData?.network
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // GET FIAT PROVIDER
    const getFiatProviders = async (country_shortcode, category, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/fiat/providers', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    category: category,
                    country_shortcode: country_shortcode
                }
            });
            var data = result?.data?.data || [];
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // RESOLVE FIAT BENEFICIARY DETAILS
    const resolveFiatBeneficiaryDetails = async (postData, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.get(constants.urls.blockchain + '/fiat/providers/resolve', {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    category: postData?.category,
                    country_shortcode: postData?.country_shortcode,
                    provider_code: postData?.provider_code,
                    account_number: postData?.account_number,
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // SEND FIAT FUNDS
    const sendFiat = async (category, postData, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.post(constants.urls.blockchain + '/fiat/send', postData, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                    category: category
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    // CONVERT FIAT FUNDS
    const convertFiat = async (from_currency, to_currency, amount, callback) => {
        try {
            const API_KEY = await constants.getData('API_KEY');
            const EMAIL = await constants.getData('EMAIL');
            const AUTH_TOKEN = await constants.getData('AUTH_TOKEN');
            var result = await instance.put(constants.urls.blockchain + '/fiat/convert', {
                from_currency: from_currency,
                to_currency: to_currency,
                amount: amount
            }, {
                params: {
                    api_key: API_KEY,
                    email: EMAIL,
                }
            });
            var data = result?.data?.data || {};
            return callback(null, data)
        }
        catch (error) {
            var response = error?.response?.data || {};
            return callback({
                message: response?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    return {
        getNetworks, getCryptoWallets, getCryptoMainWallets, getFiatWallets, getFiatTransactions, getPaymentCards, buyTokens,
        getTransactionAnalytics, getEndpointLogs, getEndpointHistory, getTokenToAmountConversion, getCryptoConversionRates,
        createFiatWallet, getFiatCurrencies, getPaymentAccounts, getCardCurrencies, getFees, calculateCryptoNetworkFee, buyCrypto,
        getConversionRates, createCard, fundCard, withdrawFromCard, createCryptoWallet, getCryptoTransactions, getCardTransactions,
        getFiatProviders, resolveFiatBeneficiaryDetails, sendFiat, convertFiat, getCryptoBalance, getCryptoReceiveDetails,
    };

}

export default useEndpoints